import { IEmailTemplate } from "../models/response/email/IEmailTemplate";
import { apiClient } from "./apiClient";

// API Endpoints
export const EMAIL_TEMPLATE_API_END_POINT = "email-template";

export const emailTemplateApi = {
    selectAll: () => apiClient.get(`email-template`),
    insert: (payload: IEmailTemplate) => apiClient.post(`email-template`, payload),
    update: (payload: IEmailTemplate) => apiClient.put(`email-template`, payload),
    delete: (id: number) => apiClient.delete(`email-template/${id}`),
}